import React from 'react';
import { Button } from 'antd';
import api from "../../../services/api";

export default class ReportFiltro extends React.Component {

    state = {
        dt_preenchimento__gte: '',
        dt_preenchimento__fin: ''
    }

    handleOnClick = async () => {
        const res = await api.get('/filtro/relatorio/planilha/', { params: this.state })
        window.open(res.data.link);
    }

    render() {
        return (
            <React.Fragment>
                <br />
                <br />
                <div
                    style={{
                        //borderStyle: "solid",
                        //borderColor: "red",
                        //borderRadius: "20px",
                        width: "100%"
                    }}
                >
                    <div
                        style={{
                            borderStyle: "solid",
                            borderColor: "black",
                            borderRadius: "20px",
                            width: "40%",
                            marginLeft: "30%",
                            padding: "20px",
                            background: "white"
                        }}
                    >
                        <h2>
                            <b>Relatório de Filtro</b>
                        </h2>
                        De: <input type="date" id="ini" className='ant-input' onChange={(e) => { this.setState({ ...this.state, dt_preenchimento__gte: document.getElementById('ini').value + 'T00:00:00Z' }) }} />
                        <br /><br />
                        Até: <input type="date" id="fin" className='ant-input' onChange={(e) => { this.setState({ ...this.state, dt_preenchimento__lte: document.getElementById('fin').value + 'T00:00:00Z' }) }} />
                        <hr />
                        <Button onClick={this.handleOnClick} type="primary">Exportar</Button>
                    </div>
                </div>
            </React.Fragment >
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/Relatorios/Filtro/index.js